import SampleReportView from "@/components/samples/SampleReportView";
import { MARS_ENERGY_GROUP_REPORT } from "@/data/sample-reports";

const MarsEnergyGroupSample = () => <SampleReportView report={MARS_ENERGY_GROUP_REPORT} />;

export default MarsEnergyGroupSample;
